import { render, staticRenderFns } from "./_opening.vue?vue&type=template&id=13e98da6"
import script from "./_opening.vue?vue&type=script&lang=js"
export * from "./_opening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports